<template>
  <canvas
    ref="canvas"
  ></canvas>
</template>

<script>
import drawIcon from '../utils/drawIcon';

export default {
  name: 'HeroBackground',
  data() {
    return {
      canvas: null,
      ctx: null,
      width: 0,
      height: 0,
      animationRequestedId: 0,
      lastDrawTime: 0,
      latestGenTime: 0,
      ghostList: [],
    };
  },
  methods: {
    draw() {
      const currentTime = (new Date()).getTime();
      const durationTime = currentTime - this.lastDrawTime;

      if (this.ghostList.length < 5 && this.latestGenTime + 200 < currentTime) {
        this.latestGenTime = currentTime;
        this.ghostList = [
          ...this.ghostList,
          {
            x: 0,
            y: (this.height * 0.1) + ((Math.random() * 2 - 1) * 200),
            scale: 0.5 + Math.random(),
            rotate: 5 + (Math.random() * 20),
            g: -0.01 + ((Math.random() * 2 - 1) * 0.01),
            vx: 2 + (Math.random() * 2 - 1),
            vy: 2 + (Math.random() * 2 - 1),
            color: {
              r: Math.floor(Math.random() * 255),
              g: Math.floor(Math.random() * 255),
              b: Math.floor(Math.random() * 255),
              a: 0.3,
            },
          },
        ];
      }

      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      this.ghostList = this.ghostList.map((v) => {
        const next = { ...v };
        const moveMag = durationTime * 0.2;
        next.x = v.x + (moveMag * v.vx);
        next.vy = v.vy + (v.g * moveMag);
        next.y = v.y + (v.vy * moveMag) + (v.g * 0.5 * moveMag * moveMag);
        return next;
      })
        .filter((v) => (v.x * v.scale) < this.width);

      this.ghostList.forEach((v) => {
        drawIcon(
          this.ctx,
          Math.floor(v.x),
          Math.floor(v.y),
          v.scale,
          v.rotate,
          v.color.r,
          v.color.g,
          v.color.b,
          v.color.a,
        );
      });

      this.lastDrawTime = currentTime;
      this.animationRequestedId = requestAnimationFrame(this.draw);
    },
    resize() {
      this.canvas.width = window.innerWidth;
      this.width = window.innerWidth;
      this.canvas.height = window.innerHeight;
      this.height = window.innerHeight;
    },
  },
  mounted() {
    this.canvas = this.$refs.canvas;
    this.ctx = this.canvas.getContext('2d');

    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(this.animationRequestedId);
      this.resize();
      this.draw();
    });

    this.lastDrawTime = (new Date()).getTime();
    this.resize();
    this.draw();
  },
};
</script>
